//dependencias
import React, { Component } from "react";

//componentes
import FacturaNEPagadasNFAction from "./facturaNEPagadasNF";

class Index extends Component {
  render() {
    return (
      <div>
        <FacturaNEPagadasNFAction />
      </div>
    );
  }
}

export default Index;

